export const props: TPageProps = {
    name: 'main',
    list: 'main',
    label: 'Главная',
}
